import { t } from '../../../../assets/utils/algolia/algoliaLocalization'
import { TranslatedHighlight } from '../../../../assets/utils/algolia/algoliaTranslation'
import useReplaceImgixUrl from '../../../../assets/utils/useReplaceImgixUrl'
import { useAppSelector } from '../store/hooks'
import { _x } from '@wordpress/i18n'
import type { LocationHit, PreparedLocationHit } from '../types'
import { formatDistance } from '../../../../assets/utils/format'
import classNames from 'classnames'

export type HitComponentProps = {
  hit: PreparedLocationHit
  onShowOnMap: (hit: LocationHit) => void
}

export default function HitComponent({ hit, onShowOnMap }: HitComponentProps) {
  const config = useAppSelector((state) => state.config)
  const displayMap = useAppSelector((state) => state.filter.displayMap)
  const placeholderLocationBlackUrl = config.placeholderLocationBlackUrl
  const placeholderLocationWhiteUrl = config.placeholderLocationWhiteUrl

  const translatedSlug = t(hit.slug ?? '', { fallback: 'any' })
  const pathComponents = [config.redirectBaseUrl]
  if (hit.status === 'microchurch' && config.microchurchSlug) {
    pathComponents.push(config.microchurchSlug)
  }
  pathComponents.push(translatedSlug)
  const linkUrl = pathComponents.join('/') // Microchurches do not have public pages for now
  const countryText = t(hit.country?.name ?? '', { fallback: 'any' })
  const distanceText = formatDistance(hit.distance)

  const replaceImgixUrl = useReplaceImgixUrl(
    config.imgixSrcUrl,
    config.imgixTargetUrl
  )

  const imgixUrl = replaceImgixUrl(hit.image?.url ?? '')

  return (
    <article data-bs-theme="dark" className="card h-100">
      <div className="card-img-top">
        {imgixUrl ? (
          <img
            src={imgixUrl}
            alt={t(hit.image?.altText ?? '', { fallback: 'any' })}
            className="card-img-top"
            draggable={false}
          />
        ) : (
          <img
            src={
              hit.status === 'icf'
                ? placeholderLocationBlackUrl
                : placeholderLocationWhiteUrl
            }
            className="card-img-top"
            alt="Location Placeholder"
            draggable={false}
          />
        )}
      </div>
      <div className="card-body">
        <div className="card-meta mb-3">
          {!!countryText && (
            <div className="card-meta-tag">
              <i className="icon fa-solid fa-location-dot" />
              <span>{countryText}</span>
            </div>
          )}
          {!!distanceText && (
            <div className="card-meta-tag">
              <i className="icon fa-solid fa-route" />
              <span>{distanceText}</span>
            </div>
          )}
        </div>
        <h3 className="card-title">
          <TranslatedHighlight attribute="name" hit={hit} />
        </h3>
        <div
          className={classNames('card-buttons w-fit-content', {
            'flex-column': displayMap
          })}
        >
          {!!hit._geoloc && !!hit._geoloc.lat && !!hit._geoloc.lng && (
            <button
              type="button"
              className="btn btn-sm btn-dark-1 card-stretched-link"
              aria-label={`${_x('Show on map', 'Location Finder Card Map Button ARIA-Text', 'icf')} ${t(hit.name, { fallback: 'none' })}`}
              onClick={() => onShowOnMap(hit)}
            >
              <span>{_x('Map', 'Location Finder Card Map Button', 'icf')}</span>
              <i className="icon fs-base-const fa-map ms-auto" />
            </button>
          )}
          {!!linkUrl && (
            <a href={linkUrl} className="btn btn-sm btn-dark-1 z-2">
              <span>
                {_x('Show more', 'Location Finder Card Website Button', 'icf')}
              </span>
              <i className="icon fs-base-const fa-arrow-right ms-auto" />
            </a>
          )}
        </div>
      </div>
    </article>
  )
}

/*
 

*/
